/* eslint-disable camelcase */
import { trackClick, trackPage } from "@companion-core/shared/app/tracking/index";
import PagesEnum from "./enums/pages";
import ChaptersEnum from "@companion-core/shared/app/tracking/enums/chapters";
import ClicksEnum from "@companion-core/shared/app/tracking/enums/clicks";
import LevelsEnum from "@companion-core/shared/app/tracking/enums/levels";
import ClickTypes from "@companion-core/shared/app/tracking/enums/click-types";
import {
  GeolocationAuthorizationTrackingProps,
  PreferencesTrackingProps,
  ProofValueTrackingProps,
  UniversesTrackingProps,
} from "@companion-core/shared/app/Interfaces/tracking";

export const trackGeolocationAuthorizationPage = ({
  universeSlug,
}: GeolocationAuthorizationTrackingProps) => {
  return trackPage({
    page: PagesEnum.Geolocation,
    page_chapter1: ChaptersEnum.Onboarding,
    page_chapter2: universeSlug || "",
  });
};

export const trackGeolocationAuthorizationClick = ({
  universeSlug,
  status,
}: GeolocationAuthorizationTrackingProps) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: `${ClicksEnum.GeolocationAuthorization}${status}`,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: universeSlug || "",
    site_level2: LevelsEnum.Contents,
  });
};

export const trackPreferencesPage = ({ universeSlug }: PreferencesTrackingProps) => {
  return trackPage({
    page: PagesEnum.Preferences,
    page_chapter1: ChaptersEnum.Onboarding,
    page_chapter2: universeSlug || "",
  });
};

export const trackPreferencesClick = ({ universeSlug, tags }: PreferencesTrackingProps) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.PreferencesValidation,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: universeSlug || "",
    click_chapter3: tags || "",
  });
};

export const trackPreferencesSkipClick = ({ universeSlug }: PreferencesTrackingProps) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.PreferencesSkip,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: universeSlug || "",
  });
};

export const trackProofValuePage = ({ universeSlug }: ProofValueTrackingProps) => {
  return trackPage({
    page: PagesEnum.ProofValue,
    page_chapter1: ChaptersEnum.Onboarding,
    page_chapter2: universeSlug || "",
  });
};

export const trackProofValueClick = ({ universeSlug }: ProofValueTrackingProps) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.ProofValueValidation,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: universeSlug || "",
  });
};

export const trackSkipProofValueClick = ({ universeSlug }: ProofValueTrackingProps) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.ProofValueSkip,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: universeSlug || "",
  });
};

export const trackUniversesPage = () => {
  return trackPage({
    page: PagesEnum.Universes,
    page_chapter1: ChaptersEnum.Onboarding,
    page_chapter2: "universe",
  });
};

export const trackUniversesClick = ({ universeSlug }: UniversesTrackingProps) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: universeSlug,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: "universe",
  });
};

export const trackSkipUniversesClick = () => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.UniversesSkip,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: "universe",
  });
};

export const trackPostListJourneyPage = ({
  slideIndex,
  totalSlides,
}: {
  slideIndex: number;
  totalSlides: number;
}) => {
  return trackPage({
    page: `Slide ${slideIndex + 1} sur ${totalSlides}`,
    page_chapter1: ChaptersEnum.Onboarding,
  });
};
